"use strict";
/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PlayArrow_1 = __importDefault(require("@material-ui/icons/PlayArrow"));
var styles_1 = require("../common/styles");
var react_player_1 = __importDefault(require("react-player"));
var Display = function (_a) {
    var src = _a.state.src, readOnly = _a.readOnly;
    return src ? (React.createElement("div", { style: { position: 'relative', height: 0, paddingBottom: '65.25%' } },
        readOnly ? null : (React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10,
            } })),
        React.createElement(react_player_1.default, { url: src, height: "100%", width: "100%", style: {
                position: 'absolute',
                width: '100% !important',
                height: '100% !important',
            } }))) : (React.createElement("div", { className: "ory-plugins-content-video-placeholder" },
        React.createElement(PlayArrow_1.default, { style: styles_1.iconStyle })));
};
exports.default = Display;
//# sourceMappingURL=VideoHtmlRenderer.js.map